import { Time } from "wombat-global/src/utilities/time";
import { QueryClient } from "@tanstack/react-query";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import persistentStorage from "../../services/persistence.service";

const indexedDbAsyncStorage = {
  getItem: async (key: string) => {
    const persistedValue = await persistentStorage.get<string>(key);
    return persistedValue;
  
  },
  setItem: async (key: string, value: string) => {
    await persistentStorage.set(key, value);
  },
  removeItem: async (key: string) => {
    await persistentStorage.delete(key);
  },
};

/**
 * This query client is used for non network requests or actions that do not require caching of data
 */
export const asyncActionsClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retryDelay: 1000,
      retry(failureCount, error) {
        if (failureCount > 2) {
          // oxlint-disable-next-line no-console
          console.error(error);
          return false;
        }
        return true;
      },
      networkMode: "always",
    },
  },
});

/**
 * default query client
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 24 * Time.hours,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnWindowFocus: true,
      retryDelay: 1000,
      retry(failureCount, error) {
        if (failureCount > 2) {
          // oxlint-disable-next-line no-console
          console.error(error);
          return false;
        }
        return true;
      },
      retryOnMount: true,
      networkMode: "online",
    },
  },
});

export const ES_QUERY_CACHE = "ES_QUERY_CACHE";
if(window.localStorage.getItem(ES_QUERY_CACHE)){
  window.localStorage.removeItem(ES_QUERY_CACHE);
}
export const queryClientPersister = createAsyncStoragePersister({
  key: ES_QUERY_CACHE,
  storage: indexedDbAsyncStorage,
});

/**
 * Cache thats for subscription management (Only firebase subscriptions right now)
 *
 * The persister should not be used by the query client because of the networkMode
 * "always". But this should help debug any issue with firebase's cache we are seeing
 */
export const subscriptionQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: Infinity,
      refetchOnMount: false,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      retryOnMount: false,
      networkMode: "always",
    },
  },
});

export const FB_QUERY_CACHE = "FB_QUERY_CACHE";
if(window.localStorage.getItem(FB_QUERY_CACHE)){
  window.localStorage.removeItem(FB_QUERY_CACHE);
}
export const subQueryClientPersister = createAsyncStoragePersister({
  key: FB_QUERY_CACHE,
  storage: indexedDbAsyncStorage,
});
